<template>
  <v-container>
    <BracketTemplate
    v-bind:welcomeText = "welcomeText"
    v-bind:desc = "desc"
    v-bind:options = "options"
    ></BracketTemplate>
  </v-container>
</template>

<script>
  import BracketTemplate from '../../components/BracketTemplate';

  export default {
    name: 'celebBracket',
    components: {
      BracketTemplate,
    },
    data: () => ({
      welcomeText: "Welcome to playmate bracket panties on edition!",
      desc: "You will be given two playmates at random, select one of the two, and they will go on to the next round of the bracket!",
      options: [
        {
          src: 'https://i.imgur.com/dV2Xrpx.jpg',
          name: 'Angela White'
        },
        {
          src: 'https://i.imgur.com/nLw4qop.jpg',
          name: 'Morgan Reese'
        },
        {
          src: 'https://i.imgur.com/Gl6LXbo.jpg',
          name: 'Klaudia Badura'
        },
        {
          src: 'https://i.imgur.com/61hDXQy.jpg',
          name: 'Mia Valenine'
        },
        {
          src: 'https://i.imgur.com/H9xnq8m.jpg',
          name: 'Chloe Miranda'
        },
        {
          src: 'https://i.imgur.com/oJg2jNp.jpg',
          name: 'Ann Denise'
        },
        {
          src: 'https://i.imgur.com/5FpBG1i.jpg',
          name: 'Mel Green'
        },
        {
          src: 'https://i.imgur.com/2J9Shku.jpg',
          name: 'Leanna Decker'
        },
        {
          src: 'https://i.imgur.com/QzQeKqI.jpg',
          name: 'Alexa Varga'
        },
        {
          src: 'https://i.imgur.com/k8tU7Zt.jpg',
          name: 'Lauren O Conner'
        },
        {
          src: 'https://i.imgur.com/J6tLDOg.jpg',
          name: 'Tahlia Paris'
        },
        {
          src: 'https://i.imgur.com/o6cHVHU.jpg',
          name: 'Blair Lindsey'
        },
        {
          src: 'https://i.imgur.com/xr6aWn4.jpg',
          name: 'Willa Prescott'
        },
        {
          src: 'https://i.imgur.com/5I3Go7D.jpg',
          name: 'Amy Green'
        },
        {
          src: 'https://i.imgur.com/xOLqBxo.jpg',
          name: 'Kelly Ryan'
        },
        {
          src: 'https://i.imgur.com/O0nWPTX.jpg',
          name: 'Elizabeth Marxs'
        },
        {
          src: 'https://i.imgur.com/jynC4hH.jpg',
          name: 'Sara Jean Underwood'
        },
        {
          src: 'https://i.imgur.com/Vtf9E16.jpg',
          name: 'Sabrina Nichole'
        },
        {
          src: 'https://i.imgur.com/6GRAKHS.jpg',
          name: 'Titania Lyn'
        },
        {
          src: 'https://i.imgur.com/XP3kb43.jpg',
          name: 'Darcie Dolce'
        },
        {
          src: 'https://i.imgur.com/DHJ5Hm9.jpg',
          name: 'Ashley Mattingly'
        },
        {
          src: 'https://i.imgur.com/CbyTjz9.jpg',
          name: 'Caryle Denise'
        },
        {
          src: 'https://i.imgur.com/bXu4QlF.jpg',
          name: 'Reed'
        },
        {
          src: 'https://i.imgur.com/O4Mgv61.jpg',
          name: 'Rebecca Carter'
        },
        {
          src: 'https://i.imgur.com/fnhyn5Z.jpg',
          name: 'Jessica Workman'
        },
        {
          src: 'https://i.imgur.com/QoCMpFy.jpg',
          name: 'Katya Clover'
        },
        {
          src: 'https://i.imgur.com/CE0dflA.jpg',
          name: 'Ali Rose'
        },
        {
          src: 'https://i.imgur.com/7gT4Ud4.jpg',
          name: 'Lindsey Pelas'
        },
        {
          src: 'https://i.imgur.com/ehYzcrE.jpg',
          name: 'Carole Hunt'
        },
        {
          src: 'https://i.imgur.com/dfXff3D.jpg',
          name: 'Angel Constance'
        },
        {
          src: 'https://i.imgur.com/sjOtHDb.jpg',
          name: 'Emily Shaw'
        },
        {
          src: 'https://i.imgur.com/iTfC3sH.jpg',
          name: 'Dalene Kurtis'
        },
      ]
    }),
    methods: {

    },
  }
</script>